var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.8994949px",
    height: "13.8994949px",
    viewBox: "0 0 13.8994949 13.8994949",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u624B\\u673A\\u53F7\\u767B\\u5F55",
    transform: "translate(-1176, -281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_close",
    transform: "translate(1168, 273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#fff",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4142136,8.58578644 L14.949,12.121 L18.4852814,8.58578644 C19.26633,7.80473785 20.5326599,7.80473785 21.3137085,8.58578644 C22.0947571,9.36683502 22.0947571,10.633165 21.3137085,11.4142136 L17.778,14.949 L21.3137085,18.4852814 C22.0947571,19.26633 22.0947571,20.5326599 21.3137085,21.3137085 C20.5326599,22.0947571 19.26633,22.0947571 18.4852814,21.3137085 L14.949,17.778 L11.4142136,21.3137085 C10.633165,22.0947571 9.36683502,22.0947571 8.58578644,21.3137085 C7.80473785,20.5326599 7.80473785,19.26633 8.58578644,18.4852814 L12.121,14.949 L8.58578644,11.4142136 C7.80473785,10.633165 7.80473785,9.36683502 8.58578644,8.58578644 C9.36683502,7.80473785 10.633165,7.80473785 11.4142136,8.58578644 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/icon_close_white.svg";
export { ForwardRef as ReactComponent };